import {
  enableProdMode,
  provideAppInitializer,
  inject,
  importProvidersFrom,
} from '@angular/core';
import { environment } from './environments/environment';
import {
  setupDefinitions,
  initializeKeycloak,
  ClientDetailsInterceptor,
  SatHeaderInterceptor,
  provideMixpanelAnalytics,
  UiModule,
} from '@irembo-andela/irembogov3-common';
import { KeycloakService, KeycloakAngularModule } from 'keycloak-angular';
import {
  HTTP_INTERCEPTORS,
  provideHttpClient,
  withInterceptorsFromDi,
  HttpClient,
} from '@angular/common/http';
import { AddHeaderInterceptor } from './app/core/interceptors/add-header-interceptor.service';
import { BrowserModule, bootstrapApplication } from '@angular/platform-browser';
import { provideAnimations } from '@angular/platform-browser/animations';
import { AppRoutingModule } from './app/app-routing.module';
import { FormsModule } from '@angular/forms';
import { NgbToastModule, NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { TranslateModule, TranslateLoader } from '@ngx-translate/core';
import {
  HttpLoaderFactory,
  SharedModule,
} from './app/modules/shared/shared.module';
import { PdfViewerModule } from 'ng2-pdf-viewer';
import { AppComponent } from './app/app.component';

// setup custom definitions to embed in NodeJS
setupDefinitions();

if (environment.production) {
  enableProdMode();
}

bootstrapApplication(AppComponent, {
  providers: [
    importProvidersFrom(
      BrowserModule,
      KeycloakAngularModule,
      AppRoutingModule,
      UiModule,
      FormsModule,
      NgbToastModule,
      NgbModule,
      TranslateModule.forRoot({
        defaultLanguage:
          localStorage.getItem('locale') ?? environment.DEFAULT_LOCALE,
        loader: {
          provide: TranslateLoader,
          useFactory: HttpLoaderFactory,
          deps: [HttpClient],
        },
        isolate: false,
      }),
      SharedModule.forRoot(),
      PdfViewerModule
    ),

    // This is the clean, correct injection context for Angular 19
    provideAppInitializer(() => {
      const keycloakService = inject(KeycloakService);
      const initFn = initializeKeycloak(keycloakService, {
        url: environment.authServiceUrl,
        realm: environment.authRealm,
        clientId: environment.authClientId,
        redirectUri: environment.authSuccessRedirectUrl,
      });
      return initFn();
    }),

    {
      provide: HTTP_INTERCEPTORS,
      useClass: ClientDetailsInterceptor,
      multi: true,
    },
    {
      provide: HTTP_INTERCEPTORS,
      useClass: AddHeaderInterceptor,
      multi: true,
    },
    {
      provide: HTTP_INTERCEPTORS,
      useClass: SatHeaderInterceptor,
      multi: true,
    },
    {
      provide: 'environment',
      useValue: environment,
    },
    ...provideMixpanelAnalytics({
      useFactory: () => ({
        isActive: environment.IS_SENDING_ANALYTICS_EVENTS_ACTIVE,
        token: environment.MIXPANEL_TOKEN,
        getLocale: () =>
          localStorage.getItem('locale') || environment.DEFAULT_LOCALE,
      }),
    }),
    provideHttpClient(withInterceptorsFromDi()),
    provideAnimations(),
  ],
}).catch(err => {
  throw err;
});
